/*
  Forwards text pasted into the desktop header search bar to the search drawer.

  The header bar (#search-box-desktop, is="predictive-search-input") only opens #search-drawer
  on click: a paste via keyboard focus or the context menu would otherwise leave the text in
  the bar, where nothing searches it. Instead we open the drawer its aria-controls points to,
  put the text in the drawer's own `q` field and fire the `input` event the drawer listens to,
  so the predictive search starts right away. The drawer's focus trap then focuses that field
  (initial-focus-selector), and the caret set below is restored at the end of the text.
  Independent from settings.algolia_enabled.
*/
(function () {
  "use strict";

  document.addEventListener("paste", function (event) {
    var source = event.target;
    if (!(source instanceof HTMLInputElement) || source.getAttribute("is") !== "predictive-search-input") return;

    var drawer = document.getElementById(source.getAttribute("aria-controls"));
    var input = drawer && drawer.querySelector('[name="q"]');
    var text = event.clipboardData ? event.clipboardData.getData("text") : "";
    if (!input || text.trim() === "") return;

    event.preventDefault();

    // Same result as a native paste: replaces the selection, keeps what was typed around it
    var value = source.value;
    var start = source.selectionStart != null ? source.selectionStart : value.length;
    var end = source.selectionEnd != null ? source.selectionEnd : value.length;
    var query = (value.slice(0, start) + text + value.slice(end)).replace(/\s+/g, " ").trim();

    source.value = "";
    input.value = query;
    input.setSelectionRange(query.length, query.length);
    input.dispatchEvent(new Event("input", { bubbles: true, cancelable: true }));
    drawer.open = true;
  });
})();
